module.exports = __webpack_public_path__ + "media/images/p-projectOverviews/info-7a10026a1e9aa158c74b702856e3c0ff.svg";